export default "__VITE_ASSET__BYNToQEr__"